import { Outlet } from "react-router-dom";

const MenuLayout = () => {
  return <Outlet />;
};

export default MenuLayout;
